import React, { useState, useEffect, useRef } from 'react';
import '../../Customer/Bucket/bucket.css';
import { ReactComponent as Delete } from '../../assets/images/svgIcons/Delete.svg';
import NoItem from '../../assets/images/empty-cart.png';
import Select from 'react-select';
import { useLocation, useNavigate } from 'react-router-dom';
import ApiService from '../../services/apiService';
import { toast } from 'react-toastify';
import { ReactComponent as BackArrow } from '../../assets/images/svgIcons/LeftArrow.svg';
import Modal from 'react-bootstrap/Modal';
import './receipt.css';
import './bucket.css';
import Calculator from './calculator/calculator';
import { connect, useSelector, useDispatch } from 'react-redux';
import CreatableSelect from 'react-select/creatable';
import { AddToCart, RemoveFromCart, clearCart, downgradeCartItemQuantity, updateCartItemQuantity, setOrderType } from '../../../Redux/actions/cartAction';
import { getAddons, getCartData, getComboData, getTableData, getTaxExplicit, getTaxImplicit, getUserId } from '../../../Redux/selecters';
import { clearTable } from '../../../Redux/actions/tableAction';
import { invokeBroadCastMessage } from '../../services/signalRService';
import DiscountModal from './cashierbucket/addDiscount';
import CustomerCreatePOpup from './createCustomerModal';
import { MdPersonAddAlt1 } from 'react-icons/md';
import userManagement from '../../services/userManagement';
import CartPopup from './cartPopup';
import { BiEdit } from 'react-icons/bi';
import PaymentComponent from './flocashPayment';
import { FaArchive, FaClock, FaMinus, FaPlus, FaReceipt, FaSearch, FaShoppingCart, FaUser } from 'react-icons/fa';
import { TbFlagDiscount } from 'react-icons/tb';
import { HiOutlineTag } from 'react-icons/hi2';
import ReceiptPrintService from '../../services/ReceiptPrintService';

// ===================== NEW: Stock helper (exported for reuse in other files) =====================
export const getItemStock = (item) => {
  const toInt = (v) => (v === undefined || v === null || isNaN(parseInt(v)) ? null : parseInt(v));

  const variantStock =
    toInt(item?.selectedVariant?.stock) ??
    toInt(item?.selectedVariant?.stockQty) ??
    toInt(item?.selectedVariant?.availableQty) ??
    toInt(item?.selectedVariant?.quantityOnHand);

  const baseStock = toInt(item?.item?.stock) ?? toInt(item?.item?.stockQty) ?? toInt(item?.item?.availableQty) ?? toInt(item?.item?.quantityOnHand);

  const topLevelStock = toInt(item?.stock) ?? toInt(item?.stockQty);

  // precedence: variant → base → top-level → default 0
  return variantStock ?? baseStock ?? topLevelStock ?? 0;
};

// ENUM CONSTANTS
const PaymentStatusEnum = {
  Pending: 0,
  Authorized: 1,
  Paid: 2,
  Refunded: 3,
  Failed: 4,
  Initiated: 5,
  Processed: 6,
  Canceled: 7,
  RefundInitiated: 8,
  PartiallyRefunded: 9,
  PartiallyPaid: 10,
};

const OrderStatusEnum = {
  NewOrder: 0,
  Accepted: 1,
  Preparing: 2,
  ReadyForDelivery: 3,
  ReadyForPickup: 4,
  OutForDelivery: 5,
  Completed: 6,
  Canceled: 7,
  Holded: 8,
  RefundInitiated: 9,
  Refunded: 10,
  PaymentPartiallyRefunded: 11,
  PaymentPartiallyPaid: 12,
};

const CashierBucket = ({ Currency, handleDisableToggle, Back, onRowSelect, showSearch, menu }) => {
  // Redux selectors
  const cartData = useSelector(getCartData);
  const comboCart = useSelector(getComboData);
  const addOnsCart = useSelector(getAddons);
  const taxImplicit = useSelector(getTaxImplicit);
  const taxExplicit = useSelector(getTaxExplicit);
  const tableData = useSelector(getTableData);
  const userId = useSelector(getUserId);
  const orderTypeR = useSelector((state) => state.cart.orderType);
  const [resumedOrderId, setResumedOrderId] = useState(null);
  const [showPrinterSettings, setShowPrinterSettings] = useState(false);
  const currentDate = new Date().toISOString();
  const [isEditingAmount, setIsEditingAmount] = useState(false);
  const [isPlacingOrder, setIsPlacingOrder] = useState(false);
  // Stock cache for cart items (keyed by material/itemNo)
  const [stockMap, setStockMap] = useState({});
  const [stockLoadingMap, setStockLoadingMap] = useState({});
  const [stockErrorMap, setStockErrorMap] = useState({});

  // Router hooks
  let navigate = useNavigate();
  const location = useLocation();
  const state = location?.state;
  const Update = state?.Update;
  const allowed = state?.allowed;
  const dispatch = useDispatch();

  // Local state
  const [dateNow, setDateNow] = useState('');
  const [buttonEnable, setButtonEnable] = useState(state?.state ? true : false);
  const [orderType, setType] = useState(orderTypeR);
  const [PaymentType, setPaymentType] = useState(1);

  const [Customers, setCustomer] = useState([]);
  const [selectedTaxPercentage, setSelectedTaxPercentage] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [taxes, setTax] = useState([]);
  const [totalRate, setTotalRate] = useState(0);
  // --- Dynamic payment method flags (Cash, Flow Cash, Card, EFT) ---
  // const selectedPaymentMethod = paymentMethod.find((m) => m.id === PaymentType);
  // const selectedPaymentName = (selectedPaymentMethod?.name || '').toLowerCase();
  // const methodName = (selectedPaymentMethod?.name || '').toLowerCase();

  // Cover both "Flow Cash" and "Flocash" variants, and also legacy id === 3
  const isFlocashPayment = PaymentType === 3;
  const isCardPayment = PaymentType === 8;
  const isEftPayment = PaymentType === 9;
  const isAccountPayment = PaymentType === 10;
  const isCashPayment = PaymentType === 1;

  // Modal states
  const [show, setShow] = useState(false);
  const [discountModal, setDiscountModalOpen] = useState(false);
  const [TaxModal, setTaxModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedCartItem, setSelectedCartItem] = useState(null);
  const [isHeldModalOpen, setIsHeldModalOpen] = useState(false);
  const [heldOrders, setHeldOrders] = useState([]);

  // Form data
  const [formData, setFormData] = useState({
    name: '',
    amountCollected: '',
    due: 0,
    change: 0,
    customerName: '',
    cardApprovalNo: '', // 👈 NEW
    cardLast4Digits: '', // 👈 NEW
    eftReference: '', // 👈 NEW
    accountNumber: '', // 👈 NEW
  });

  // Permissions
  const [areAllButtonsDisabled, setAreAllButtonsDisabled] = useState(false);
  const [areDiscountDisable, setDiscountDisable] = useState(false);
  const [isPaymentAllow, setPaymentAllow] = useState(true);
  const [areTaxDisable, setTaxDisable] = useState(false);

  // Authentication
  let token = localStorage.getItem('Token');
  let Permission = userManagement?.getUserCrud(token);
  let role = userManagement?.getUserRole(token);
  const getMaterialNoFromCartItem = (item) => {
    return (
      item?.selectedVariant?.itemNo || // preferred (variant)
      item?.item?.itemNo || // plain item
      item?.id || // fallback
      item?.item?.recordId ||
      item?.item?.record_Id ||
      ''
    );
  };
  const getCachedStockQty = (item) => {
    const materialNo = getMaterialNoFromCartItem(item);
    if (!materialNo) return null;

    const fromMap = stockMap[materialNo]?.quantityNew;
    if (typeof fromMap === 'number') return fromMap;

    // fallback to stockData saved on the item (from CartModal)
    if (item.stockData && typeof item.stockData.quantityNew === 'number') {
      return item.stockData.quantityNew;
    }

    return null;
  };
  const normalizeSerialNumbers = (item) => {
    const raw = item?.serialNumbers ?? item?.item?.serialNumbers ?? item?.itemSerialNumbers ?? item?.item?.itemSerialNumbers ?? [];

    const single = item?.serialNumber ?? item?.item?.serialNumber ?? item?.itemSerialNumber ?? item?.item?.itemSerialNumber ?? null;

    let arr = [];

    const pushValue = (v) => {
      if (v === undefined || v === null) return;

      // If already an array, push each
      if (Array.isArray(v)) {
        v.forEach(pushValue);
        return;
      }

      // If comma-separated string, split
      v.toString()
        .split(',')
        .map((x) => x.trim())
        .filter(Boolean)
        .forEach((x) => arr.push(x));
    };

    pushValue(raw);
    pushValue(single);

    // unique + keep order
    arr = [...new Set(arr)];
    return arr;
  };

  const fetchStockForCartItem = async (item) => {
    const materialNo = getMaterialNoFromCartItem(item);
    if (!materialNo) return null;

    // Avoid duplicate calls
    if (stockMap[materialNo]) return stockMap[materialNo];

    setStockLoadingMap((prev) => ({ ...prev, [materialNo]: true }));
    setStockErrorMap((prev) => ({ ...prev, [materialNo]: null }));

    try {
      const apiService = new ApiService();
      const requestBody = {
        request: {
          endpointUrl: 'https://tp-apg-testza.multichoice.co.za/stock-processing-confirmation-api',
          templateName: 'MaterialStockByLocationRequest',
          CountryIdentifier: 'zaf',
          Plant: '2402',
          Material: materialNo.toString(),
          token: await localStorage.getItem('Token'),
        },
      };

      const response = await apiService.post('GET_MATERIAL_STOCK', requestBody);

      if (response?.data?.statusCode === 200 || response?.data?.statusCode === 201) {
        const result = response.data.result;
        setStockMap((prev) => ({ ...prev, [materialNo]: result }));
        return result;
      } else {
        setStockErrorMap((prev) => ({ ...prev, [materialNo]: 'Unable to fetch stock information' }));
        return null;
      }
    } catch (error) {
      console.error('Cashier stock check failed:', error);
      setStockErrorMap((prev) => ({ ...prev, [materialNo]: 'Stock check failed' }));
      return null;
    } finally {
      setStockLoadingMap((prev) => ({ ...prev, [materialNo]: false }));
    }
  };

  // HELPER FUNCTIONS
  const getPaymentStatus = (paymentType, amountCollected, totalAmount) => {
    if (paymentType === 3) {
      return PaymentStatusEnum.Initiated; // Flocash
    } else if (paymentType === 1 || paymentType === 2) {
      if (amountCollected === 0) {
        return PaymentStatusEnum.Pending;
      } else if (amountCollected >= totalAmount) {
        return PaymentStatusEnum.Paid;
      } else if (amountCollected > 0) {
        return PaymentStatusEnum.PartiallyPaid; // Fixed: was using 1, now using 10
      }
    }
    return PaymentStatusEnum.Paid;
  };

  useEffect(() => {
    if (buttonEnable && PaymentType !== 3) {
      // Only for non-Flocash payments
      const totalAmount = calculateTotalPriceWithTaxesAndDiscounts();
      setFormData((prev) => ({
        ...prev,
        amountCollected: totalAmount, // Auto-fill with total amount
        change: 0, // Reset change to 0
        due: totalAmount,
      }));
    }
  }, [buttonEnable, PaymentType, cartData, selectedTaxPercentage]);
  useEffect(() => {
    cartData?.forEach((item) => {
      const materialNo = getMaterialNoFromCartItem(item);
      if (materialNo && !stockMap[materialNo] && !stockLoadingMap[materialNo]) {
        fetchStockForCartItem(item);
      }
    });
  }, [cartData]); // you can add stockMap/stockLoadingMap if you like

  const getOrderStatus = (paymentStatus, isHeldOrder = false) => {
    if (isHeldOrder) {
      return OrderStatusEnum.Holded;
    }
    if (paymentStatus === PaymentStatusEnum.Paid || paymentStatus === PaymentStatusEnum.PartiallyPaid) {
      return OrderStatusEnum.Accepted;
    }
    return OrderStatusEnum.NewOrder;
  };

  const getFlocashPaymentStatus = (tranStatus) => {
    switch (tranStatus) {
      case 'APPROVED':
        return PaymentStatusEnum.Paid;
      case 'DECLINED':
        return PaymentStatusEnum.Failed;
      case 'PENDING':
        return PaymentStatusEnum.Pending;
      case 'PROCESSING':
        return PaymentStatusEnum.Processed;
      case 'INITIATED':
        return PaymentStatusEnum.Initiated;
      case 'CANCELED':
      case 'CANCELLED':
        return PaymentStatusEnum.Canceled;
      default:
        return PaymentStatusEnum.Pending;
    }
  };

  const getOrderTypeEnumValue = (orderType) => {
    switch (orderType) {
      case 'Dine-In':
        return 0;
      case 'Delivery':
        return 2;
      case 'Take-Away':
        return 1;
      case 'Pick-up':
        return 7;
      default:
        return 1;
    }
  };

  // CALCULATION FUNCTIONS
  const calculateItemPrice = (item) => {
    if (item?.selectedVariant?.salePrice) {
      return parseFloat(item.selectedVariant.salePrice);
    } else if (item?.item?.salePrice) {
      return parseFloat(item.item.salePrice);
    } else if (item?.price) {
      return parseFloat(item.price);
    }
    return 0;
  };

  const getItemDiscountPrice = (item) => {
    const discount = item?.discount || item?.itemData?.discount || 0;
    const discountType = item?.discountType || item?.itemData?.discountType;

    if (!discount || discount === 0) return 0;

    const itemPrice = calculateItemPrice(item);

    if (discountType === 'Percentage') {
      return (itemPrice * parseFloat(discount)) / 100;
    } else {
      return parseFloat(discount);
    }
  };

  const calculateItemTax = (item) => {
    if (item?.selectedVariant?.vat) {
      const vatAmount = parseFloat(item.selectedVariant.vat);
      return isNaN(vatAmount) ? 0 : vatAmount;
    }

    const itemPrice = calculateItemPrice(item);
    let taxRate = 0;

    if (item?.selectedVariant?.taxRate) {
      taxRate = parseFloat(item.selectedVariant.taxRate);
    } else if (item?.item?.taxRate) {
      taxRate = parseFloat(item.item.taxRate);
    } else if (item?.item?.vat && parseFloat(item.item.vat) < 100) {
      taxRate = parseFloat(item.item.vat);
    }
    // removed stray debugger
    return taxRate > 0 ? (taxRate / 100) * itemPrice : 0;
  };

  const calculateTotalPrice = () => {
    let totalPrice = 0;
    cartData?.forEach((item) => {
      if (!item?.void && !item?.itemData?.voidItem && !item?.itemData?.refunded) {
        const itemPrice = calculateItemPrice(item);
        totalPrice += itemPrice * item?.quantity;
      }
    });
    return totalPrice;
  };

  const calculateTotalTax = () => {
    let totalTax = 0;

    cartData?.forEach((item) => {
      if (!item?.void && !item?.itemData?.voidItem && !item?.itemData?.refunded) {
        const itemTax = calculateItemTax(item);
        totalTax += itemTax * item?.quantity;
      }
    });

    const additionalTax =
      selectedTaxPercentage?.reduce((total, tax) => {
        const taxAmount = (totalRate * tax.value.taxPercentage) / 100;
        return total + taxAmount;
      }, 0) || 0;

    return totalTax + additionalTax;
  };

  const calculateTotalDiscount = () => {
    let totalDiscount = 0;

    cartData?.forEach((item) => {
      if (!item?.void && !item?.itemData?.voidItem && !item?.itemData?.refunded) {
        const itemDiscount = getItemDiscountPrice(item);
        const isOrderLevel = item?.isOrderLevelDiscount || item?.itemData?.isOrderLevelDiscount;
        const type = item?.discountType || item?.itemData?.discountType; // 'Percentage' or 'Amount'

        if (isOrderLevel && type === 'Amount') {
          totalDiscount += itemDiscount; // use once only
        } else {
          totalDiscount += itemDiscount * item?.quantity;
        }
      }
    });

    return totalDiscount;
  };

  const calculateTotalPriceWithTaxesAndDiscounts = () => {
    const subtotal = calculateTotalPrice();
    const totalTax = calculateTotalTax();
    const totalDiscount = calculateTotalDiscount();
    const total = Math.max(0, subtotal + totalTax - totalDiscount);
    return Number(total.toFixed(2)); // ensures decimal format (e.g. 25.50)
  };
  // COMPUTED VALUES
  const totalAmount = calculateTotalPriceWithTaxesAndDiscounts();
  const isPaymentSufficient =
    isFlocashPayment || // Flow Cash/Flocash
    (typeof formData.amountCollected === 'number' && formData.amountCollected >= totalAmount) ||
    (typeof formData.amountCollected === 'string' && parseFloat(formData.amountCollected) >= totalAmount);
  // METADATA MAPPING FUNCTION
  const mapDynamicMetaData = (item) => {
    const result = [];

    if (item?.selectedVariant) {
      result.push({
        metaItemId: parseInt(item?.selectedVariant?.recordId || 0),
        type: 4, // Variant type
        menuItemId: parseInt(item?.item?.recordId || item?.item?.record_Id || 0),
        metaItemIndex: parseInt(item?.index || 0),
        metaItemName: item?.selectedVariant?.itemDescription || '',
        metaItemPrice: parseFloat(item?.selectedVariant?.salePrice || 0),
      });
    }

    if (item?.selectedAdOn && item?.selectedAdOn?.length > 0) {
      item?.selectedAdOn?.forEach((addon, index) => {
        result.push({
          metaItemId: parseInt(addon?.recordId || 0),
          type: 2, // Add-on type
          menuItemId: parseInt(item?.item?.recordId || item?.item?.record_Id || 0),
          metaItemIndex: parseInt(item?.index || 0),
          metaItemName: addon?.itemName || '',
          metaItemPrice: parseFloat(addon?.salePrice || 0),
        });
      });
    }

    if (item?.selectedModifier && item?.selectedModifier?.length > 0) {
      item?.selectedModifier?.forEach((modifier, index) => {
        result.push({
          metaItemId: parseInt(modifier?.recordId || 0),
          type: 3, // Modifier type
          menuItemId: parseInt(item?.item?.recordId || item?.item?.record_Id || 0),
          metaItemIndex: parseInt(item?.index || 0),
          metaItemName: modifier?.itemName || '',
          metaItemPrice: parseFloat(modifier?.salePrice || 0),
        });
      });
    }

    return result;
  };

  // API FUNCTIONS
  const GetMethods = async () => {
    try {
      const apiService = new ApiService();
      let res = await apiService.get('GET_PAYMENT_METHOD');
      const filteredMenu = res.data.result.filter((item) => item?.active === true);
      setPaymentMethod(filteredMenu);
    } catch (error) {
      console.error('Error fetching paymentMethod data:', error);
    }
  };

  const GetCostumer = async () => {
    const apiService = new ApiService();
    try {
      let res = await apiService.get('GET_COSTUMER');
      setCustomer(res?.data?.result);
    } catch (error) {
      console.error('Error fetching customer data:', error);
    }
  };

  const GetTax = async () => {
    const apiService = new ApiService();
    let res = await apiService.get('GET_TAX');
    const filteredTax = res?.data?.result?.filter((tax) => tax?.vat === true);
    setTax(filteredTax);
  };

  const GetOrders = async () => {
    const apiService = new ApiService();
    let param = `?OrderStatus=${OrderStatusEnum.Holded}`;
    let res = await apiService.getApiParamater('GET_ORDERS', param);
    setHeldOrders(res?.data?.result || []);
  };

  const PrinterSettingsModal = ({ show, onHide }) => {
    const [printerConfig, setPrinterConfig] = useState({
      paperWidth: 80,
      enableAutoprint: true,
      copies: 1,
      showPreview: false,
      printLogo: true,
      printBarcode: true,
      printQRCode: false,
    });

    useEffect(() => {
      const savedConfig = localStorage.getItem('printerConfig');
      if (savedConfig) {
        setPrinterConfig(JSON.parse(savedConfig));
      }
    }, [show]);

    const handleSave = () => {
      ReceiptPrintService.savePrinterConfig(printerConfig);
      toast.success('Printer settings saved!');
      onHide();
    };

    const testPrint = async () => {
      try {
        await ReceiptPrintService.testPrinter();
        toast.success('Test receipt sent to printer!');
      } catch (error) {
        toast.error('Print failed: ' + error.message);
      }
    };

    return (
      <Modal show={show} onHide={onHide} size="md">
        <Modal.Header closeButton>
          <Modal.Title>🖨️ Printer Settings</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">Paper Width</label>
            <select
              className="form-select"
              value={printerConfig.paperWidth}
              onChange={(e) => setPrinterConfig({ ...printerConfig, paperWidth: parseInt(e.target.value) })}
            >
              <option value={58}>58mm (Small)</option>
              <option value={80}>80mm (Standard)</option>
            </select>
          </div>

          <div className="mb-3">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                checked={printerConfig.enableAutoprint}
                onChange={(e) => setPrinterConfig({ ...printerConfig, enableAutoprint: e.target.checked })}
              />
              <label className="form-check-label">Auto-print receipts after payment</label>
            </div>
          </div>

          <div className="mb-3">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                checked={printerConfig.showPreview}
                onChange={(e) => setPrinterConfig({ ...printerConfig, showPreview: e.target.checked })}
              />
              <label className="form-check-label">Show preview before printing</label>
            </div>
          </div>

          <div className="mb-3">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                checked={printerConfig.printLogo}
                onChange={(e) => setPrinterConfig({ ...printerConfig, printLogo: e.target.checked })}
              />
              <label className="form-check-label">Print Pro360 logo on receipt</label>
            </div>
          </div>

          <div className="mb-3">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                checked={printerConfig.printBarcode}
                onChange={(e) => setPrinterConfig({ ...printerConfig, printBarcode: e.target.checked })}
              />
              <label className="form-check-label">Print barcode</label>
            </div>
          </div>

          <div className="mb-3">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                checked={printerConfig.printQRCode}
                onChange={(e) => setPrinterConfig({ ...printerConfig, printQRCode: e.target.checked })}
              />
              <label className="form-check-label">Print QR code</label>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={testPrint}>
            🧪 Test Print
          </button>
          <button className="btn btn-primary" onClick={handleSave}>
            💾 Save Settings
          </button>
        </Modal.Footer>
      </Modal>
    );
  };
  const createSoapSaleOrder = async () => {
    try {
      const soapRequest = {
        request: {
          endpointUrl: 'https://tp-apg-testza.multichoice.co.za/ws/SalesProcessingConfirmationAPI.HTTP_Port/1.0',
          templateName: 'SalesOrderCreateRequest',
          countryIdentifier: 'zaf',
          plant: '2402',
          salesType: 'L',
          referenceId: `QSS-${Date.now()}`,
          pricingDate: new Date().toISOString().split('T')[0],
          cashier: 'EMS',
          items:
            cartData
              ?.filter((item) => !item?.void && !item?.itemData?.voidItem && !item?.itemData?.refunded)
              ?.map((item) => ({
                material: item?.id || item?.item?.itemNo || `${item?.item?.recordId}`,
                quantity: parseInt(item?.quantity || 1),
              })) || [],
        },
      };

      console.log('Creating SOAP Sale Order:', soapRequest);

      const apiService = new ApiService();
      const soapResponse = await apiService.post('CREATE_SOAP_SALE_ORDER', soapRequest);

      if (soapResponse?.data?.statusCode === 200 || soapResponse?.data?.isSuccessful) {
        console.log('SOAP Sale Order created successfully:', soapResponse.data);

        // Extract both referenceID and id from response
        return {
          success: true,
          data: soapResponse.data,
          referenceID: soapResponse.data?.result?.referenceID || soapResponse.data?.referenceID,
          soapSaleOrderId: soapResponse.data?.result?.salesOrderNumber || soapResponse.data?.salesOrderNumber,
        };
      } else {
        console.error('SOAP Sale Order failed:', soapResponse?.data);
        return {
          success: false,
          error: soapResponse?.data?.message || 'SOAP order creation failed',
        };
      }
    } catch (error) {
      console.error('SOAP Sale Order API error:', error);
      return {
        success: false,
        error: error?.response?.data?.message || error.message || 'Failed to create SOAP order',
      };
    }
  };

  const decrementSoapStock = async (soapSaleOrderId, referenceId) => {
    try {
      const filteredCart = cartData?.filter((item) => !item?.void && !item?.itemData?.voidItem && !item?.itemData?.refunded) || [];

      const stockIssueList = [];

      filteredCart.forEach((item) => {
        const material = item?.id || item?.item?.itemNo || `${item?.item?.recordId}`;
        const qty = parseInt(item?.quantity || 1, 10);

        // 🔹 Same fallbacks as orderItems
        const rawSerials = item.serialNumbers || item.item?.serialNumbers || [];

        const singleSerial = item.serialNumber || item.item?.serialNumber || null;

        // Normalize to array
        let itemSerials = [];
        if (Array.isArray(rawSerials)) {
          itemSerials = rawSerials;
        } else if (rawSerials) {
          itemSerials = [rawSerials];
        }

        // If single serial exists and not already in array, add it
        if (singleSerial) {
          const trimmedSingle = singleSerial.toString().trim();
          if (trimmedSingle && !itemSerials.includes(trimmedSingle)) {
            itemSerials.push(trimmedSingle);
          }
        }

        // Clean + trim serials
        itemSerials = itemSerials.map((sn) => (sn || '').toString().trim()).filter((sn) => sn);

        // 🔹 SINGLE OBJECT per cart line
        stockIssueList.push({
          material,
          quantity: qty,
          // 👉 pass array when we have multiple serials, same as create order
          serialNumbers: itemSerials.length ? itemSerials : [],
          // if you also need a single field:
          // serialNumber: itemSerials.length === 1 ? itemSerials[0] : null,
        });
      });

      const decrementRequest = {
        request: {
          endpointUrl: 'https://tp-apg-testza.multichoice.co.za/ws/StockProcessingConfirmation_InService.HTTP_Port2/1.0',
          token: token,
          templateName: 'GoodsMovementForReferenceIDRequest',
          parameters: {
            CountryIdentifier: 'zaf',
            cashier: 'EMS',
            referenceID: referenceId,
            stockIssueList,
          },
        },
      };
      debugger;
      console.log('Decrementing SOAP Stock (grouped by item, serialNumbers array):', JSON.stringify(decrementRequest, null, 2));

      const apiService = new ApiService();
      const response = await apiService.post('UPDATE_SOAP_STOCK', decrementRequest);

      if (response?.data?.statusCode === 200 || response?.data?.isSuccessful) {
        console.log('Stock decremented successfully:', response.data);
        return { success: true, data: response.data };
      } else {
        console.error('Stock decrement failed:', response?.data);
        return {
          success: false,
          error: response?.data?.message || 'Stock decrement failed',
        };
      }
    } catch (error) {
      console.error('Stock decrement API error:', error);
      return {
        success: false,
        error: error?.response?.data?.message || error.message,
      };
    }
  };

  // Updated createNewOrderWithPayment with proper flow
  const createNewOrderWithPayment = async (totalAmount) => {
    let soapResult = null;
    let stockResult = null;

    let orderId = null;

    try {
      // STEP 1: Create SOAP Sale Order first
      soapResult = await createSoapSaleOrder();

      if (!soapResult.success) {
        toast.error(`SOAP API failed: ${soapResult.error}`);
        return;
      }

      toast.success('SOAP order created successfully');
      console.log('SOAP Result:', soapResult);
      if (soapResult.soapSaleOrderId && soapResult.referenceID) {
        stockResult = await decrementSoapStock(soapResult.soapSaleOrderId, soapResult.referenceID);

        if (!stockResult.success) {
          console.error('Stock decrement failed:', stockResult.error);
          toast.warning('Order created but stock update failed. Please update manually.');
        } else {
          console.log('Stock decremented successfully');
        }
      }
      const currentDate = new Date().toISOString();
      const totalTax = calculateTotalTax();
      const totalDiscount = calculateTotalDiscount();

      const firstCartItemWithDiscount = cartData.find((item) => item?.discountId || item?.itemData?.discountId);
      const firstCartItemWithPromotion = cartData.find((item) => item?.promotionId || item?.itemData?.promotionId);

      const paymentStatus = getPaymentStatus(PaymentType, formData.amountCollected, totalAmount);
      const orderStatus = getOrderStatus(paymentStatus);

      // STEP 2: Create Order with SOAP references
      const orderBody = {
        orderDate: currentDate,
        orderType: getOrderTypeEnumValue(orderType),
        orderSource: 0,
        orderStatus: orderStatus,
        orderAmount: totalAmount,
        calculatedTax: totalTax,
        totalDiscount: totalDiscount,
        amountCollected: formData?.amountCollected || 0,
        amountReturned: formData?.change || 0,
        customerType: 0,
        customerId: formData?.customerName?.value?.id || 'Guest',
        customerName: formData?.customerName?.label || 'Guest',
        tableId: orderType === 'Dine-In' ? tableData?.[0]?.id || 0 : 0,
        discountId: firstCartItemWithDiscount?.discountId || firstCartItemWithDiscount?.itemData?.discountId || 0,
        promotionId: firstCartItemWithPromotion?.promotionId || firstCartItemWithPromotion?.itemData?.promotionId || 0,
        paymentStatus: paymentStatus,
        invoiceNumber: 'INVOICE_' + Date.now(),
        currency: Currency?.currency?.code || 'PKR',
        terminalId: 'string',
        branchId: 0,
        res_Branch_Id: 0,
        soapSaleOrderRefId: soapResult.referenceID || 'string', // Use referenceID
        soapSaleOrderId: soapResult.soapSaleOrderId || null, // Add soapSaleOrderId
        SaleOrderStatus: 'Success',
        GoodsMovementStatus: stockResult?.success ? 'Success' : 'Failed',
        GoodsMovementRemarks: stockResult?.error || '',
        orderItems: cartData?.map((item, index) => {
          const itemPrice = calculateItemPrice(item);
          const itemDiscount = getItemDiscountPrice(item);
          const serialArr = normalizeSerialNumbers(item);
          return {
            itemId: parseInt(item?.item?.recordId || item?.item?.record_Id || 0),
            itemName: item?.name || item?.item?.itemName || 'Item',
            menuItemName: item?.name || item?.item?.itemName || 'Item',
            menuItemPrice: itemPrice,
            menuItemDiscount: itemDiscount,
            menuItemTax: calculateItemTax(item),
            itemAmount: itemPrice,
            quantity: parseInt(item.quantity || 1),
            kitchenInstructions: item.specialInstructions || '',
            voidItem: item?.void || item?.itemData?.voidItem || false,
            refunded: item?.refund || item?.itemData?.refunded || false,
            taxIncluded: item?.selectedVariant?.vat ? true : false,
            itemIndex: index,
            invoiceId: 0,
            discountId: item?.discountId || item?.itemData?.discountId || 0,
            discountType: item?.discountType || item?.itemData?.discountType || 'Percentage',
            discountValue: item?.discount || item?.itemData?.discount || 0,
            // serialNumbers: item.serialNumbers || item.item?.serialNumbers || [],
            itemSerialNumbers: serialArr.join(','),
            serialNumbersCsv: serialArr,
          };
        }),
        itemSerialNumbers: cartData?.serialNumber,
        cardLast4Digits: isCardPayment ? parseInt(formData.cardLast4Digits) : null,
        cardApprovalNo: isCardPayment ? formData.cardApprovalNo : null,
        eftReference: isEftPayment ? formData.eftReference : null,

        orderItemsMeta: cartData?.flatMap(mapDynamicMetaData),
        orderTax:
          selectedTaxPercentage?.map((tax) => ({
            taxId: tax.value?.id || 0,
            amount: (totalRate * tax.value.taxPercentage) / 100 || 0,
            percentage: tax.value.taxPercentage || 0,
            type: 'Tax',
          })) || [],
        loggedInUserId: userId?.toString() || 'string',
      };

      console.log('Creating Order with SOAP references:', orderBody);

      const apiService = new ApiService();
      const res = await apiService.post('CREATE_ORDER', orderBody);

      if (res?.data?.statusCode === 201) {
        const orderId = res?.data?.result?.id;
        // menu();
        if (!isFlocashPayment && PaymentType) {
          await createPayment(orderId, totalAmount);
          console.log('Payment created successfully');
        }

        // STEP 4: Decrement Stock AFTER payment

        // Print receipt
        try {
          const printerConfig = JSON.parse(localStorage.getItem('printerConfig') || '{}');
          if (printerConfig.enableAutoprint !== false) {
            const receiptData = {
              orderId: orderId,
              orderDate: currentDate,
              orderItems: cartData.map((item) => ({
                itemName: item?.name || item?.item?.itemName,
                quantity: item.quantity,
                menuItemPrice: calculateItemPrice(item),
                specialInstructions: item.specialInstructions || '',
                selectedVariant: item?.selectedVariant?.itemDescription || null,
              })),
              subtotal: calculateTotalPrice(),
              tax: totalTax,
              discount: totalDiscount,
              total: totalAmount,
              amountPaid: formData.amountCollected || 0,
              change: formData.change || 0,
              customerName: formData?.customerName?.label || 'Walk-in Customer',
              orderType: orderType,
              tableNumber: tableData?.[0]?.tableName || null,
              invoiceNumber: 'INV-' + orderId,
              soapReferenceId: soapResult.referenceID,
              soapOrderId: soapResult.soapSaleOrderId,
              paymentMethod: paymentMethod.find((p) => p.id === PaymentType)?.name || 'Payment',
            };

            await ReceiptPrintService.printReceipt(receiptData, Currency?.currency);
            console.log('✅ Receipt printed successfully');
          }
        } catch (printError) {
          console.error('❌ Printing failed:', printError);
          toast.warning('Order created but printing failed.');
        }

        toast.success('Order Created Successfully');
        handleUpdateTable();
        handlePromotion();
        invokeBroadCastMessage('New Order Received.');
        handleEnable();

        // Clear state
        dispatch(setOrderType(''));
        dispatch(clearCart());
        dispatch(clearTable());
        setType('');
        setFormData({ customerName: '', amountCollected: 0, change: 0 });
        setSelectedTaxPercentage([]);
      } else {
        toast.warning('Order creation failed. Please try again!');
      }
    } catch (error) {
      console.error('Order creation failed:', error);
      toast.error('Failed to create order.');
    }
  };

  const createPayment = async (orderId, amount) => {
    try {
      const method = paymentMethod.find((p) => p.id === PaymentType);
      const methodName = method?.name || 'Payment';
      const lower = methodName.toLowerCase();

      const isFlocash =
        lower.includes('flow cash') || lower.includes('flocash') || lower.includes('flo cash') || lower.includes('flowcash') || PaymentType === 3;

      // Flocash uses its own flow (createFlocashPayment), skip here
      if (isFlocash) return;

      const isCard = lower === 'card' || lower.includes('card');
      const isEft = lower === 'eft' || lower.includes('eft') || lower.includes('bank transfer') || lower.includes('transfer');

      const paymentStatus = Number(formData.amountCollected || 0) >= Number(amount || 0) ? PaymentStatusEnum.Paid : PaymentStatusEnum.PartiallyPaid;

      let notes = `Payment via ${methodName}`;
      if (isCard) {
        notes += ` | Approval#: ${formData.cardApprovalNo || '-'}, Last 4 digits: ${formData.cardLast4Digits || '-'}`;
      } else if (isEft) {
        notes += ` | Ref: ${formData.eftReference || '-'}`;
      }

      const paymentBody = {
        orderId,
        paymentMethodId: PaymentType,
        paymentMethodName: methodName,
        amount: amount,
        paymentMethod: PaymentType,
        paymentAmount: amount,
        amountPaid: formData.amountCollected,
        change: isCard || isEft ? 0 : formData.change || 0,
        paymentStatus,
        transactionId: `TXN_${Date.now()}`,
        paymentDate: new Date().toISOString(),
        currency: Currency?.currency?.code || 'PKR',
        customerId: formData?.customerName?.value?.id || userId?.toString() || 'Guest',
        customerName: formData?.customerName?.label || 'Guest',
        notes,
        paymentType: PaymentType,

        // ✅ NEW FIELDS
        cardLast4Digits: isCard ? parseInt(formData.cardLast4Digits) : null,
        cardApprovalNo: isCard ? formData.cardApprovalNo : null,
        eftReference: isEft ? formData.eftReference : null,
        accountNumber: isAccountPayment ? formData.accountNumber : null,
      };

      const apiService = new ApiService();
      const paymentRes = await apiService.post('CREATE_PAYMENT', paymentBody);

      if (paymentRes?.data?.statusCode === 201) {
        console.log('Payment created successfully');
      } else {
        console.warn('Payment creation failed, but order was created');
      }
    } catch (error) {
      console.error('Payment creation failed:', error);
    }
  };

  const placeOrderWithFlocash = async (paymentResult) => {
    let soapResult = null;
    let orderId = null;

    try {
      if (cartData?.length === 0) {
        toast.warning('Please choose at least a single item to order!');
        return;
      }

      // STEP 1: Create SOAP Sale Order
      soapResult = await createSoapSaleOrder();

      if (!soapResult.success) {
        toast.error(`SOAP API failed: ${soapResult.error}`);
        return;
      }

      toast.success('SOAP order created successfully');

      const currentDate = new Date().toISOString();
      const totalTax = calculateTotalTax();
      const totalDiscount = calculateTotalDiscount();
      const totalAmount = calculateTotalPriceWithTaxesAndDiscounts();

      const firstCartItemWithDiscount = cartData.find((item) => item?.discountId || item?.itemData?.discountId);
      const firstCartItemWithPromotion = cartData.find((item) => item?.promotionId || item?.itemData?.promotionId);

      const paymentStatus = getFlocashPaymentStatus(paymentResult.tranStatus);
      const orderStatus = paymentResult.tranStatus === 'APPROVED' ? OrderStatusEnum.Accepted : OrderStatusEnum.NewOrder;

      const orderBody = {
        orderDate: currentDate,
        orderType: getOrderTypeEnumValue(orderType),
        orderSource: 0,
        orderStatus: orderStatus,
        orderAmount: totalAmount,
        calculatedTax: totalTax,
        TotalDiscount: totalDiscount,
        amountCollected: paymentResult.requestAmount || totalAmount,
        amountReturned: 0,
        customerType: 0,
        surfOrderId: soapResult.referenceID || paymentResult.tranId || 'string',
        soapSaleOrderId: soapResult.soapSaleOrderId || null,
        customerId: formData?.customerName?.value?.id || userId?.toString() || 'Guest',
        customerName: formData?.customerName?.label || 'Guest',
        tableId: orderType === 'Dine-In' ? tableData?.[0]?.id || 0 : 0,
        discountId: firstCartItemWithDiscount?.discountId || firstCartItemWithDiscount?.itemData?.discountId || 0,
        promotionId: firstCartItemWithPromotion?.promotionId || firstCartItemWithPromotion?.itemData?.promotionId || 0,
        paymentStatus: paymentStatus,
        invoiceNumber: 'INVOICE_' + Date.now(),
        currency: Currency?.currency?.code || 'PKR',
        terminalId: paymentResult.posId || 'string',
        branchId: 0,
        res_Branch_Id: 0,
        soapSaleOrderRefId: soapResult.referenceID || paymentResult.tranId || 'string',

        orderItems: cartData?.map((item, index) => {
          const itemPrice = calculateItemPrice(item);
          const itemDiscount = getItemDiscountPrice(item);
          const qty = parseInt(item.quantity || 1, 10);
          const serialArr = normalizeSerialNumbers(item);

          return {
            itemId: parseInt(item?.item?.recordId || item?.item?.record_Id || 0),
            itemName: item?.name || item?.item?.itemName || 'Item',
            menuItemName: item?.name || item?.item?.itemName || 'Item',
            menuItemPrice: itemPrice,
            menuItemDiscount: itemDiscount,
            menuItemTax: calculateItemTax(item),
            itemAmount: itemPrice,
            quantity: parseInt(item.quantity || 1),
            kitchenInstructions: item.specialInstructions || '',
            voidItem: item?.void || item?.itemData?.voidItem || false,
            refunded: item?.refund || item?.itemData?.refunded || false,
            taxIncluded: item?.selectedVariant?.vat ? true : false,
            itemIndex: index,
            invoiceId: 0,
            discountId: item?.discountId || item?.itemData?.discountId || 0,
            discountType: item?.discountType || item?.itemData?.discountType || 'Percentage',
            discountValue: item?.discount || item?.itemData?.discount || 0,

            // 🆕 serials
            serialNumbers: serialArr,
            itemSerialNumbers: serialArr.join(','),
          };
        }),

        orderItemsMeta: cartData?.flatMap(mapDynamicMetaData),
        orderTax:
          selectedTaxPercentage?.map((tax) => ({
            taxId: tax.value?.id || 0,
            amount: (totalRate * tax.value.taxPercentage) / 100 || 0,
            percentage: tax.value.taxPercentage || 0,
            type: 'Tax',
          })) || [],
        loggedInUserId: userId?.toString() || 'string',
      };

      console.log('Flocash Order Body:', orderBody);

      const apiService = new ApiService();
      const res = await apiService.post('CREATE_ORDER', orderBody);

      if (res?.data?.statusCode === 201) {
        const orderId = res?.data?.result?.id;
        // menu();
        await createFlocashPayment(orderId, totalAmount, paymentResult);

        toast.success('Order Created Successfully with Flocash Payment');
        handleUpdateTable();
        handlePromotion();
        handleEnable();
        invokeBroadCastMessage('New Order Received.');

        dispatch(setOrderType(''));
        dispatch(clearCart());
        dispatch(clearTable());
        setType('');
        setFormData({ customerName: '', amountCollected: 0, change: 0 });
        setSelectedTaxPercentage([]);
        setPaymentType(paymentMethod);
      } else {
        toast.warning('Something went wrong. Please try again!');
      }
    } catch (error) {
      console.error('Flocash order creation failed:', error);
      toast.error('Failed to place order. See console for details.');
    }
  };
  const isCardInfoValid =
    !isCardPayment || ((formData.cardLast4Digits || '').toString().trim().length === 4 && (formData.cardApprovalNo || '').toString().trim().length > 0);

  const isEftInfoValid = !isEftPayment || (formData.eftReference || '').toString().trim().length > 0;

  const isAccountInfoValid = !isAccountPayment || (formData.accountNumber || '').toString().trim().length > 0;
  const isPaymentFormValid = isPaymentSufficient && isCardInfoValid && isEftInfoValid && isAccountInfoValid;

  const handleCustomerSelect = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      customerName: selectedOption,
    }));
  };

  const handleCustomerCreated = async (newCustomerData) => {
    try {
      console.log('🎉 New customer created:', newCustomerData);

      // STEP 1: First, add the customer to the local state immediately
      const newCustomerOption = {
        value: newCustomerData,
        label: `${newCustomerData.name} (${newCustomerData.mobileNumber || newCustomerData.phoneNumber || newCustomerData.email})`,
      };

      // STEP 2: Update customers list in state immediately (don't wait for API)
      setCustomer((prevCustomers) => {
        // Check if customer already exists to avoid duplicates
        const exists = prevCustomers.some((customer) => customer.id === newCustomerData.id);
        if (!exists) {
          return [...prevCustomers, newCustomerData];
        }
        return prevCustomers;
      });

      // STEP 3: Set the newly created customer as selected immediately
      setFormData((prev) => ({
        ...prev,
        customerName: newCustomerOption,
      }));

      console.log('📋 Customer auto-selected:', newCustomerOption);

      // STEP 4: Refresh the customer list from API in background (but don't wait for it)
      GetCostumer().catch((error) => {
        console.warn('Failed to refresh customer list from API:', error);
      });

      // STEP 5: Close the modal and show success
      handleClose();
      toast.success(`Customer "${newCustomerData.name}" created and selected successfully!`);
    } catch (error) {
      console.error('❌ Error handling customer creation:', error);
      toast.error('Failed to select the new customer. Please select manually.');
    }
  };

  const createFlocashPayment = async (orderId, amount, paymentResult) => {
    try {
      const paymentStatus = getFlocashPaymentStatus(paymentResult.tranStatus);

      const paymentBody = {
        orderId: orderId,
        paymentMethodId: 3,
        paymentMethodName: paymentMethod.find((p) => p.id === 3)?.name || 'Flocash',
        amount: amount,
        paymentAmount: amount,
        amountPaid: paymentResult.requestAmount || amount,
        change: 0,
        paymentStatus: paymentStatus,
        transactionId: paymentResult.tranId || paymentResult.messageId || `FLOCASH_${Date.now()}`,
        paymentDate: new Date().toISOString(),
        currency: Currency?.currency?.code || 'PKR',
        customerId: formData?.customerName?.value?.id || userId?.toString() || 'Guest',
        customerName: formData?.customerName?.label || 'Guest',
        notes: `Flocash Payment - Message ID: ${paymentResult.messageId}, Status: ${paymentResult.tranStatus}`,
        paymentType: 3,
        flocashData: {
          messageId: paymentResult.messageId,
          posId: paymentResult.posId,
          tranType: paymentResult.tranType,
          tranStatus: paymentResult.tranStatus,
          tranId: paymentResult.tranId,
          currency: paymentResult.currency,
          requestAmount: paymentResult.requestAmount,
          approvalCode: paymentResult.approvalCode,
          responseCode: paymentResult.responseCode,
          responseMessage: paymentResult.responseMessage,
        },
        accountNumber: isAccountPayment ? formData.accountNumber : null,
      };

      const apiService = new ApiService();
      const paymentRes = await apiService.post('CREATE_PAYMENT', paymentBody);

      if (paymentRes?.data?.statusCode === 201) {
        try {
          const printerConfig = JSON.parse(localStorage.getItem('printerConfig') || '{}');

          if (printerConfig.enableAutoprint !== false) {
            const receiptData = {
              orderId: orderId,
              orderDate: currentDate,
              orderItems: cartData.map((item) => ({
                itemName: item?.name || item?.item?.itemName,
                quantity: item.quantity,
                menuItemPrice: calculateItemPrice(item),
                specialInstructions: item.specialInstructions || '',
                selectedVariant: item?.selectedVariant?.itemDescription || null,
              })),
              subtotal: calculateTotalPrice(),
              tax: calculateTotalTax(),
              totalDiscount: calculateTotalDiscount(),
              total: calculateTotalPriceWithTaxesAndDiscounts(),
              amountPaid: paymentResult.requestAmount || calculateTotalPriceWithTaxesAndDiscounts(),
              change: 0,
              customerName: formData?.customerName?.label || 'Walk-in Customer',
              orderType: orderType,
              tableNumber: tableData?.[0]?.tableName || null,
              invoiceNumber: 'INV-' + orderId,
              paymentMethod: 'Flocash',
            };

            await ReceiptPrintService.printReceipt(receiptData, Currency?.currency);
          }
        } catch (printError) {
          console.error('Printing failed:', printError);
        }
        // ===== END RECEIPT PRINTING =====

        console.log('Flocash payment record created successfully');
      } else {
        console.warn('Flocash payment record creation failed, but order was created');
      }
    } catch (error) {
      console.error('Flocash payment record creation failed:', error);
    }
  };

  const handleHoldPayment = async () => {
    try {
      if (!cartData || cartData.length === 0) {
        toast.warning('Please add item to process!');
        return;
      }

      const currentDate = new Date().toISOString();
      const totalAmount = calculateTotalPriceWithTaxesAndDiscounts();
      const totalTax = calculateTotalTax();
      const totalDiscount = calculateTotalDiscount();

      const firstCartItemWithDiscount = cartData.find((item) => item?.discountId || item?.itemData?.discountId);
      const firstCartItemWithPromotion = cartData.find((item) => item?.promotionId || item?.itemData?.promotionId);

      const orderBody = {
        orderDate: currentDate,
        orderType: getOrderTypeEnumValue(orderType),
        orderSource: 0,
        orderStatus: OrderStatusEnum.Holded,
        orderAmount: totalAmount,
        calculatedTax: totalTax,
        totalDiscount: totalDiscount,
        amountCollected: 0,
        amountReturned: 0,
        customerType: 0,
        customerId: formData?.customerName?.value?.id || userId?.toString() || 'Guest',
        customerName: formData?.customerName?.label || 'Guest',
        tableId: orderType === 'Dine-In' ? tableData?.[0]?.id || 0 : 0,
        discountId: firstCartItemWithDiscount?.discountId || firstCartItemWithDiscount?.itemData?.discountId || 0,
        promotionId: firstCartItemWithPromotion?.promotionId || firstCartItemWithPromotion?.itemData?.promotionId || 0,
        paymentStatus: PaymentStatusEnum.Pending,
        invoiceNumber: 'INVOICE_' + Date.now(),
        currency: Currency?.currency?.code || 'PKR',
        terminalId: 'string',
        branchId: 0,
        res_Branch_Id: 0,
        surfOrderId: 'string',

        orderItems: cartData?.map((item, index) => {
          const qty = parseInt(item.quantity || 1, 10);
          const serialArr = normalizeSerialNumbers(item);

          return {
            itemId: parseInt(item?.item?.recordId || item?.item?.record_Id || 0),
            itemName: item?.name || item?.item?.itemName || 'Item',
            menuItemName: item?.name || item?.item?.itemName || 'Item',
            menuItemPrice: calculateItemPrice(item),
            menuItemDiscount: getItemDiscountPrice(item),
            menuItemTax: calculateItemTax(item),
            itemAmount: calculateItemPrice(item),
            quantity: parseInt(item.quantity || 1),
            serialNumbers: serialArr,
            itemSerialNumbers: serialArr.join(','),
            kitchenInstructions: item.specialInstructions || '',
            voidItem: false,
            refunded: false,
            taxIncluded: item?.selectedVariant?.vat ? true : false,
            itemIndex: index,
            invoiceId: 0,
            discountId: item?.discountId || item?.itemData?.discountId || 0,
            discountType: item?.discountType || item?.itemData?.discountType || 'Percentage',
            discountValue: item?.discount || item?.itemData?.discount || 0,
          };
        }),

        orderItemsMeta: cartData?.flatMap(mapDynamicMetaData),
        orderTax:
          selectedTaxPercentage?.map((tax) => ({
            taxId: tax.value?.id || 0,
            amount: (totalRate * tax.value.taxPercentage) / 100 || 0,
            percentage: tax.value.taxPercentage || 0,
            type: 'Tax',
          })) || [],
        loggedInUserId: userId?.toString() || 'string',
      };

      const apiService = new ApiService();
      const res = await apiService.post('CREATE_ORDER', orderBody);

      if (res?.data?.statusCode === 201) {
        // menu();
        toast.success('Order is on hold now');
        dispatch(setOrderType(''));
        dispatch(clearCart());
        dispatch(clearTable());
        setType('');
        setSelectedTaxPercentage([]);
        setFormData({ customerName: '', amountCollected: 0, change: 0 });
        GetOrders();
      } else {
        toast.warning('Something went wrong. Please try again!');
      }
    } catch (error) {
      console.error('Error while holding order:', error);
      toast.error('Failed to hold order. Please try again.');
    }
  };

  const processPaymentForExistingOrder = async (orderId, totalAmount) => {
    try {
      if (PaymentType && formData.amountCollected > 0) {
        if (!isFlocashPayment && formData.amountCollected > 0) {
          await createPayment(orderId, totalAmount);
        }
        await updateOrderPaymentStatus(orderId, totalAmount);

        toast.success('Payment Processed Successfully');
        invokeBroadCastMessage(`Payment completed for Order #ORD-${orderId}`);

        handleEnable();
        dispatch(setOrderType(''));
        dispatch(clearCart());
        dispatch(clearTable());
        setType('');
        setFormData({ customerName: '', amountCollected: 0, change: 0 });
        setSelectedTaxPercentage([]);
      } else {
        toast.warning('Please select payment method and enter amount');
      }
    } catch (error) {
      console.error('Payment processing failed:', error);
      toast.error('Failed to process payment');
    }
  };

  const updateOrderPaymentStatus = async (orderId, totalAmount) => {
    try {
      const paymentStatus = formData.amountCollected >= totalAmount ? PaymentStatusEnum.Paid : PaymentStatusEnum.PartiallyPaid;

      const paymentStatusUpdate = {
        id: orderId,
        paymentStatus: paymentStatus,
        amountCollected: formData.amountCollected,
        amountReturned: formData.change || 0,
      };

      const apiService = new ApiService();
      await apiService.put('UPDATE_ORDER', paymentStatusUpdate);

      console.log('Order payment status updated successfully');
    } catch (error) {
      console.error('Failed to update order payment status:', error);
    }
  };

  const placeOrder = async () => {
    if (isPlacingOrder) return;
    try {
      setIsPlacingOrder(true);

      if (cartData?.length === 0) {
        toast.warning('Please choose at least a single item to order!');
        return;
      }

      const totalAmount = calculateTotalPriceWithTaxesAndDiscounts();

      // Check if this is a resumed held order
      if (resumedOrderId) {
        await updateHeldOrderWithPayment(resumedOrderId, totalAmount);
      }
      // Check if this is an existing order payment (from your current logic)
      else if (Update && state?.originalOrderData) {
        await processPaymentForExistingOrder(parseInt(Update), totalAmount);
      }
      // Otherwise, create a new order
      else {
        await createNewOrderWithPayment(totalAmount);
      }
    } catch (error) {
      console.error('Payment processing failed:', error);
      toast.error('Failed to process payment. See console for details.');
    } finally {
      setIsPlacingOrder(false); // Reset loader
    }
  };

  // UTILITY FUNCTIONS
  const handlePromotion = async () => {
    try {
      const itemWithData = cartData.find((item) => item.selectedPromotionDetails || item.itemData?.selectedPromotionDetails);

      if (itemWithData) {
        const selectedPromotionDetails = itemWithData.selectedPromotionDetails || itemWithData.itemData?.selectedPromotionDetails;

        const datareq = {
          id: selectedPromotionDetails?.promotionDetialsId,
          promotionID: selectedPromotionDetails?.promotionID,
          vouchorNo: selectedPromotionDetails?.vouchorNo,
          fromDate: selectedPromotionDetails?.fromDate,
          toDate: selectedPromotionDetails?.toDate,
          status: selectedPromotionDetails?.status,
          useCount: selectedPromotionDetails?.useCount + 1,
        };

        const apiService = new ApiService();
        await apiService.put('UPDATE_PROMOTION_DETAIL', datareq);
      }
    } catch (error) {
      console.error('Error updating promotion:', error);
    }
  };

  const handleUpdateTable = async () => {
    try {
      if (orderType === 'Dine-In' && tableData?.[0]?.id) {
        const datareq = {
          id: tableData[0].id,
          seatCapacity: tableData[0].selectedChairs,
          status: 2,
        };

        const apiService = new ApiService();
        await apiService.put('UPDATE_TABLE', datareq);
      }
    } catch (error) {
      console.error('Error updating table:', error);
    }
  };

  // Add this state variable to track if we're working with a held order

  // Updated handleHeldOrder function
  const handleHeldOrder = (heldOrder) => {
    dispatch(clearCart());
    dispatch(clearTable());

    // IMPORTANT: Store the held order ID for later payment processing
    setResumedOrderId(heldOrder.id);

    const orderItems = heldOrder.orderItems || [];
    const orderItemsMeta = heldOrder.orderItemsMeta || [];

    // Create a map for easier lookup of meta data - same as handleEditOrder
    const orderItemsMetaMap = {};
    orderItemsMeta?.forEach((orderItemMeta) => {
      const menuItemId = orderItemMeta.menuItemId;
      if (!orderItemsMetaMap[menuItemId]) {
        orderItemsMetaMap[menuItemId] = [];
      }
      orderItemsMetaMap[menuItemId].push(orderItemMeta);
    });

    // Process each order item and add them one by one to Redux - same structure as handleEditOrder
    orderItems?.forEach((orderItem, index) => {
      const menuItemId = orderItem.itemId;
      const itemMeta = orderItemsMetaMap[menuItemId] || [];

      // Find variant (type 4 is variant)
      const selectedVariant = itemMeta.find((meta) => meta.type === 4) || null;

      // Find add-ons (type 2 is add-on)
      const selectedAdOn = itemMeta.filter((meta) => meta.type === 2) || [];

      // Find modifiers (type 3 is modifier)
      const selectedModifier = itemMeta.filter((meta) => meta.type === 3) || [];

      const processedItem = {
        itemData: {
          ...orderItem,
          id: orderItem.itemId,
          itemId: orderItem.itemId,
          menuItemName: orderItem.menuItemName || orderItem.itemName || `Item ${orderItem.itemId}`,
          menuItemPrice: orderItem.menuItemPrice,
          orderItemsMeta: itemMeta,
          itemIndex: orderItem.itemIndex || index,
          voidItem: orderItem.voidItem || false,
          refunded: orderItem.refunded || false,
          // Include discount data if available
          discountId: orderItem.discountId || 0,
          discountType: orderItem.discountType || 'Percentage',
          discount: orderItem.discountValue || 0,
          // Include promotion data if available
          promotionId: heldOrder.promotionId || 0,
        },
        quantity: orderItem.quantity || 1,
        specialInstructions: orderItem.kitchenInstructions || '',
        selectedVariant: selectedVariant
          ? {
              recordId: selectedVariant.metaItemId,
              itemDescription: selectedVariant.metaItemName,
              salePrice: selectedVariant.metaItemPrice,
            }
          : null,
        selectedAdOn: selectedAdOn.map((addon) => ({
          recordId: addon.metaItemId,
          itemName: addon.metaItemName,
          salePrice: addon.metaItemPrice,
        })),
        selectedModifier: selectedModifier.map((modifier) => ({
          recordId: modifier.metaItemId,
          itemName: modifier.metaItemName,
          salePrice: modifier.metaItemPrice,
        })),
        void: orderItem.voidItem || false,
        refund: orderItem.refunded || false,
        index: index,
        // Create the item object that matches your cart structure
        item: {
          recordId: orderItem.itemId,
          record_Id: orderItem.itemId,
          itemName: orderItem.itemName || orderItem.menuItemName,
          salePrice: orderItem.menuItemPrice,
          itemNo: orderItem.itemId,
        },
        // Add the name and price at the top level for compatibility
        name: orderItem.itemName || orderItem.menuItemName,
        price: orderItem.menuItemPrice,
        // Include discount information at the top level
        discountId: orderItem.discountId || 0,
        discountType: orderItem.discountType || 'Percentage',
        discount: orderItem.discountValue || 0,
        // Include promotion information if available
        promotionId: heldOrder.promotionId || 0,
      };

      // Add each item individually to Redux using AddToCart
      dispatch(AddToCart(processedItem));
    });

    // Set additional order information
    if (heldOrder.orderType !== undefined) {
      const orderTypeMap = {
        0: 'Dine-In',
        1: 'Take-Away',
        2: 'Delivery',
        7: 'Pick-up',
      };
      const orderTypeName = orderTypeMap[heldOrder.orderType] || 'Take-Away';
      dispatch(setOrderType(orderTypeName));
      setType(orderTypeName);
    }

    // Set customer information if available
    if (heldOrder.customerName && heldOrder.customerId) {
      const customerOption = {
        value: { id: heldOrder.customerId },
        label: heldOrder.customerName,
      };
      setFormData((prev) => ({
        ...prev,
        customerName: customerOption,
      }));
    }

    // Set tax information if available
    if (heldOrder.orderTax && heldOrder.orderTax.length > 0) {
      const taxOptions = heldOrder.orderTax.map((tax) => ({
        value: {
          id: tax.taxId,
          taxPercentage: tax.percentage,
          name: `Tax ${tax.percentage}%`,
        },
        label: `Tax ${tax.percentage}%`,
      }));
      setSelectedTaxPercentage(taxOptions);
    }

    setIsHeldModalOpen(false);
    toast.success('Held order loaded successfully');
  };

  const updateHeldOrderWithPayment = async (orderId, totalAmount) => {
    try {
      const totalTax = calculateTotalTax();
      const totalDiscount = calculateTotalDiscount();

      const paymentStatus = getPaymentStatus(PaymentType, formData.amountCollected, totalAmount);
      const orderStatus = getOrderStatus(paymentStatus);

      // Update the existing held order
      const updateOrderBody = {
        id: orderId,
        orderStatus: orderStatus,
        orderAmount: totalAmount,
        calculatedTax: totalTax,
        totalDiscount: totalDiscount,
        amountCollected: formData?.amountCollected || 0,
        amountReturned: formData?.change || 0,
        paymentStatus: paymentStatus,
        customerId: formData?.customerName?.value?.id || userId?.toString() || 'Guest',
        customerName: formData?.customerName?.label || 'Guest',
      };

      console.log('Updating Held Order:', updateOrderBody);

      const apiService = new ApiService();
      const res = await apiService.put('UPDATE_ORDER', updateOrderBody);

      if (res?.data?.statusCode === 200 || res?.data?.statusCode === 204) {
        // Create payment record if cash payment and amount collected
        if (!isFlocashPayment && formData.amountCollected > 0) {
          await createPayment(orderId, totalAmount);
        }

        toast.success('Order Updated and Payment Processed Successfully');
        handleUpdateTable();
        handlePromotion();
        invokeBroadCastMessage(`Held order #${orderId} completed with payment.`);
        handleEnable();

        // Clear everything and reset state
        dispatch(setOrderType(''));
        dispatch(clearCart());
        dispatch(clearTable());
        setType('');
        setFormData({ customerName: '', amountCollected: 0, change: 0 });
        setSelectedTaxPercentage([]);
        setResumedOrderId(null); // Reset the resumed order ID

        // Refresh held orders list
        GetOrders();
      } else {
        toast.warning('Something went wrong while updating the order. Please try again!');
      }
    } catch (error) {
      console.error('Held order update failed:', error);
      toast.error('Failed to update held order.');
    }
  };

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      timeZoneName: 'short',
    };
    return new Intl.DateTimeFormat('en-US', options).format(date);
  };

  // ===================== STOCK-AWARE EVENT HANDLERS =====================
  const handleDelete = (itemNo, index) => {
    onRowSelect(null);
    dispatch(RemoveFromCart(itemNo, index));
  };

  const handleQuantityChange = async (item, index) => {
    const materialNo = getMaterialNoFromCartItem(item);

    if (!materialNo) {
      toast.error('Unable to identify item for stock check');
      return;
    }

    // 1) Try cached stock first
    let stockQty = getCachedStockQty(item);

    // 2) If not known yet, call API now
    if (stockQty === null || stockQty === undefined) {
      toast.info('Checking stock, please wait...');
      const stockInfo = await fetchStockForCartItem(item);
      stockQty = stockInfo?.quantityNew;
    }

    if (stockQty === null || stockQty === undefined) {
      toast.error('Unable to verify stock for this item');
      return;
    }

    const currentQty = parseInt(item?.quantity || 0, 10);

    if (stockQty <= 0) {
      toast.error('This item is out of stock');
      return;
    }

    if (currentQty + 1 > stockQty) {
      toast.warning(`Only ${stockQty} items available in stock`);
      return;
    }

    dispatch(updateCartItemQuantity(index, item?.item?.itemNo || item?.item?.recordId));
  };

  const handleQuantityChangeDec = (item, index) => {
    if (item.quantity > 1) {
      dispatch(downgradeCartItemQuantity(index, item?.item?.itemNo || item?.item?.recordId));
    }
  };

  const handleInputFromCalculator = (value) => {
    if (value === 'C') {
      const currentValue = formData?.amountCollected?.toString() || '';
      const newValue = currentValue.slice(0, -1);
      const totalAmount = calculateTotalPriceWithTaxesAndDiscounts();
      const numericValue = parseFloat(newValue) || 0;
      const change = numericValue - totalAmount;

      setFormData((prevState) => ({
        ...prevState,
        amountCollected: numericValue,
        change: change > 0 ? change : 0,
      }));
    } else {
      const currentValue = formData?.amountCollected?.toString() || '';
      const newValue = parseFloat(currentValue) + parseFloat(value);
      const totalAmount = calculateTotalPriceWithTaxesAndDiscounts();
      const numericValue = parseFloat(newValue) || 0;
      const change = numericValue - totalAmount;

      setFormData((prevState) => ({
        ...prevState,
        amountCollected: numericValue,
        change: change > 0 ? change : 0,
      }));
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'amountCollected') {
      const totalAmount = calculateTotalPriceWithTaxesAndDiscounts();
      const numericValue = parseFloat(value) || 0;
      const change = numericValue - totalAmount;
      setFormData((prev) => ({
        ...prev,
        [name]: numericValue, // Store as number, not string
        change: change > 0 ? change : 0,
      }));
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleclearCart = () => {
    dispatch(clearCart());
    dispatch(clearTable());
    setSelectedTaxPercentage([]);
    setFormData({ ...formData, customerName: '' });
    setType('');
    dispatch(setOrderType(''));
    setResumedOrderId(null);
    Back();
    onRowSelect(null);
  };

  const handleDisable = () => {
    // if (orderType === null || orderType === undefined) {
    //   toast.warning('Please select order Type');
    // } else {
    if (cartData?.length > 0 || comboCart?.length > 0) {
      const totalAmount = calculateTotalPriceWithTaxesAndDiscounts();
      setButtonEnable(true);
      setFormData((prev) => ({
        ...prev,
        amountCollected: totalAmount, // Auto-fill with total amount
        change: 0,
      }));
    } else {
      toast.warning('Please add item to process!');
    }
    // }
  };

  const handleEnable = () => {
    setButtonEnable(false);
    setResumedOrderId(null); // Reset resumed order ID when going back
    Back();
  };

  const handleOrderType = (Type) => {
    dispatch(clearTable());
    dispatch(setOrderType(Type));
    setType(Type);
    handleDisableToggle(Type || 'Dine-In');
  };

  const handlePaymentType = (Type) => {
    setPaymentType(Type?.id);
  };

  const handleSelectedTax = (selectedItem) => {
    setSelectedTaxPercentage(selectedItem || []);
  };

  // MODAL HANDLERS
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const closeDiscountModal = () => setDiscountModalOpen(false);
  const openDiscountModal = () => {
    if (cartData?.length > 0) {
      setDiscountModalOpen(true);
    } else {
      toast.error('No items in the cart to add discount!');
    }
  };
  const closeTaxModal = () => setTaxModalOpen(false);
  const openTaxModal = () => setTaxModalOpen(true);
  const openHeldModal = () => setIsHeldModalOpen(true);
  const closeHeldModal = () => setIsHeldModalOpen(false);

  // EFFECTS
  useEffect(() => {
    // Set permissions
    const isOrderPunchEnabled = Permission?.includes('Order Punch.add') && Permission.includes('Order Punch.query');
    setAreAllButtonsDisabled(!isOrderPunchEnabled);
    const isDiscountDisable = Permission?.includes('Discount.add') && Permission.includes('Discount.query');
    setDiscountDisable(!isDiscountDisable);
    const isTaxDisable = Permission?.includes('Tax.add') && Permission.includes('Tax.query');
    setTaxDisable(!isTaxDisable);
    const isPaymentAllow = Permission?.includes('Payment.add') && Permission.includes('Payment.query');
    setPaymentAllow(isPaymentAllow);

    // Set date
    const currentDate = new Date();
    const options = { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' };
    const formattedDate = currentDate.toLocaleDateString('en-US', options);
    setDateNow(formattedDate);

    // Set order type
    if (!tableData || tableData?.length === 0) {
      setType(orderType);
      handleDisableToggle(orderType);
    } else {
      setType('Dine-In');
      handleDisableToggle('Dine-In');
    }
  }, [tableData]);

  useEffect(() => {
    GetMethods();
    setTotalRate(calculateTotalPrice());
    GetCostumer();
    GetTax();
    GetOrders();
  }, [cartData, comboCart]);

  useEffect(() => {
    const totalAmount = calculateTotalPriceWithTaxesAndDiscounts();
    setFormData((prev) => ({ ...prev, due: totalAmount }));
  }, [cartData, selectedTaxPercentage]);

  // STYLES
  const containerStyle = {
    minHeight: '78vh',
    backgroundColor: '#f8f9fa',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  };

  const cardStyle = {
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    border: '1px solid #e9ecef',
    transition: 'all 0.2s ease',
  };

  const headerCardStyle = {
    ...cardStyle,
    background: 'linear-gradient(135deg,rgb(120, 102, 234) 0%, #764ba2 100%)',
    color: 'white',
    marginBottom: '20px',
  };

  // RENDER
  return (
    <div style={containerStyle} className="p-1">
      {/* Search Bar */}
      {/* <div className="mb-4">
        <div
          className="search-bar d-flex align-items-center justify-content-center"
          onClick={() => showSearch()}
          style={{
            ...cardStyle,
            padding: '16px 20px',
            cursor: 'pointer',
            backgroundColor: '#f8f9fa',
            border: '2px dashed #dee2e6',
            transition: 'all 0.3s ease',
          }}
          onMouseEnter={(e) => {
            e.target.style.borderColor = '#adb5bd';
            e.target.style.backgroundColor = '#e9ecef';
          }}
          onMouseLeave={(e) => {
            e.target.style.borderColor = '#dee2e6';
            e.target.style.backgroundColor = '#f8f9fa';
          }}
        >
          <FaSearch className="me-3" size={20} color="#6c757d" />
          <span style={{ fontSize: '16px', color: '#6c757d', fontWeight: '500' }}>Search Items to Add to Cart</span>
        </div>
      </div> */}

      {/* Header */}
      <div style={headerCardStyle} className="p-4">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <div className="mb-1" style={{ fontWeight: '600', fontSize: '14px', opacity: '0.9', color: '#fff' }}>
              {dateNow}
            </div>
            <div className="d-flex align-items-center">
              <FaShoppingCart className="me-2" size={16} />
              <span style={{ fontSize: '14px', fontWeight: '500' }}>POS Terminal</span>
            </div>
          </div>
          <div className="text-end">
            <div className="d-flex align-items-center justify-content-end mb-1">
              <FaUser className="me-2" size={14} />
              <span style={{ fontSize: '14px', fontWeight: '500' }}>{userManagement.getUserName(token)}</span>
            </div>
            <div style={{ fontSize: '12px', opacity: '0.8' }}>Cashier</div>
          </div>
        </div>
      </div>

      {/* Payment Methods */}
      {buttonEnable && (
        <div style={cardStyle} className="p-4 mb-4">
          <h6 className="mb-3 d-flex align-items-center" style={{ fontWeight: '600', color: '#495057' }}>
            <FaReceipt className="me-2" />
            Payment Method
          </h6>
          <div className="d-flex gap-3 flex-wrap">
            {paymentMethod?.map((val, key) => (
              <button
                key={key}
                className={`payment-method-btn ${PaymentType === val?.id ? 'active' : ''}`}
                onClick={() => handlePaymentType(val)}
                style={{
                  padding: '12px 20px',
                  border: PaymentType === val?.id ? '2px solid #007bff' : '2px solid #e9ecef',
                  borderRadius: '8px',
                  backgroundColor: PaymentType === val?.id ? '#e3f2fd' : 'white',
                  color: PaymentType === val?.id ? '#007bff' : '#6c757d',
                  fontWeight: '500',
                  fontSize: '14px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  minWidth: '120px',
                }}
              >
                {val?.name}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Main Content */}
      {buttonEnable === false ? (
        <>
          {/* Cart Display */}
          <div style={{ ...cardStyle, display: 'flex', flexDirection: 'column', height: '100%' }} className="mb-4">
            {cartData?.length < 1 ? (
              <>
                <div className="text-center py-5">
                  <img src={NoItem} alt="No items" style={{ maxWidth: '200px', opacity: '0.7' }} />
                  <h5 className="mt-3 text-muted">Your cart is empty</h5>
                  <p className="text-muted">Add items to get started</p>
                </div>
                <div className="row g-3 mt-2">
                  <div className="col-md-6">
                    <button
                      onClick={handleHoldPayment}
                      className="btn w-100"
                      style={{
                        backgroundColor: '#6e5199',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '8px',
                        padding: '12px',
                        fontSize: '14px',
                        fontWeight: '600',
                        transition: 'all 0.2s ease',
                        boxShadow: '0 2px 4px rgba(255, 193, 7, 0.2)',
                      }}
                    >
                      <FaClock className="me-2" />
                      Suspend Sale
                    </button>
                  </div>
                  <div className="col-md-6">
                    <button
                      onClick={() => setIsHeldModalOpen(true)}
                      className="btn w-100"
                      style={{
                        backgroundColor: '#6c757d',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        padding: '12px',
                        fontSize: '14px',
                        fontWeight: '600',
                        transition: 'all 0.2s ease',
                        boxShadow: '0 2px 4px rgba(108, 117, 125, 0.2)',
                      }}
                    >
                      <FaArchive className="me-2" />
                      Resume Sale
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <>
                {/* Header - Fixed */}
                <div className="p-4 border-bottom" style={{ flexShrink: 0 }}>
                  <h6 className="mb-0 d-flex align-items-center" style={{ fontWeight: '600', color: '#495057' }}>
                    <FaShoppingCart className="me-2" />
                    Cart Items ({cartData.length})
                  </h6>
                </div>

                {/* Scrollable Items Section */}
                <div
                  className="table-responsive"
                  style={{
                    height: cartData.length > 3 ? '180px' : 'auto', // Fixed height when more than 3 items
                    maxHeight: '300px', // Maximum height to show ~3 items
                    overflowY: cartData.length > 3 ? 'auto' : 'visible', // Enable scroll only when needed
                    overflowX: 'hidden',
                  }}
                >
                  <table className="table mb-0">
                    <thead
                      style={{
                        backgroundColor: '#f8f9fa',
                        position: 'sticky',
                        top: 0,
                        zIndex: 10,
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                      }}
                    >
                      <tr>
                        <th style={{ padding: '16px', fontWeight: '600', fontSize: '14px', color: '#495057', border: 'none' }}>Item</th>
                        <th style={{ padding: '16px', fontWeight: '600', fontSize: '14px', color: '#495057', border: 'none' }}>Variant</th>
                        <th style={{ padding: '16px', fontWeight: '600', fontSize: '14px', color: '#495057', border: 'none', textAlign: 'center' }}>
                          Quantity
                        </th>
                        <th style={{ padding: '16px', fontWeight: '600', fontSize: '14px', color: '#495057', border: 'none', textAlign: 'right' }}>Total</th>
                        <th style={{ padding: '16px', fontWeight: '600', fontSize: '14px', color: '#495057', border: 'none', textAlign: 'center' }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cartData.map((item, index) => {
                        const itemPrice = calculateItemPrice(item);
                        const itemTotal = itemPrice * item.quantity;
                        const itemDiscount = getItemDiscountPrice(item);

                        const materialNo = getMaterialNoFromCartItem(item);
                        const cachedStockQty = getCachedStockQty(item);
                        const isCheckingStock = stockLoadingMap[materialNo];
                        const stockError = stockErrorMap[materialNo];

                        const outOfStock = cachedStockQty !== null && cachedStockQty !== undefined && cachedStockQty <= 0;

                        const atMax = cachedStockQty !== null && cachedStockQty !== undefined && item.quantity >= cachedStockQty;

                        return (
                          <tr
                            key={index}
                            onClick={() => onRowSelect?.(item)}
                            style={{
                              cursor: 'pointer',
                              transition: 'background-color 0.2s ease',
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#f8f9fa';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = 'transparent';
                            }}
                          >
                            <td style={{ padding: '16px', borderBottom: '1px solid #f1f3f4' }}>
                              <div>
                                <div style={{ fontWeight: '600', fontSize: '14px', color: '#212529', marginBottom: '4px' }}>
                                  {item?.name || item?.item?.itemName}
                                </div>
                                {/* {isCheckingStock && (
                                  <div className="text-muted" style={{ fontSize: '12px' }}>
                                    Checking stock...
                                  </div>
                                )}

                                {stockError && !isCheckingStock && (
                                  <div className="text-danger" style={{ fontSize: '12px' }}>
                                    {stockError}
                                  </div>
                                )}

                                {!isCheckingStock && !stockError && cachedStockQty != null && cachedStockQty > 0 && (
                                  <div className="text-muted" style={{ fontSize: '12px' }}>
                                    In stock: {cachedStockQty}
                                  </div>
                                )}

                                {!isCheckingStock && !stockError && cachedStockQty != null && cachedStockQty <= 0 && (
                                  <div className="text-danger" style={{ fontSize: '12px', fontWeight: 600 }}>
                                    Out of stock
                                  </div>
                                )} */}

                                {itemDiscount > 0 && (
                                  <div className="d-flex align-items-center">
                                    <TbFlagDiscount size={14} className="me-1 text-success" />
                                    <span style={{ fontSize: '12px', color: '#28a745', fontWeight: '500' }}>
                                      {item?.discountType === 'Percentage' ? `${item?.discount}% off` : `${Currency?.currency?.code} ${item?.discount} off`}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </td>
                            <td style={{ padding: '16px', borderBottom: '1px solid #f1f3f4' }}>
                              {item?.selectedVariant?.itemDescription && (
                                <span style={{ fontSize: '13px', color: '#6c757d', fontStyle: 'italic' }}>{item.selectedVariant.itemDescription}</span>
                              )}
                            </td>
                            <td style={{ padding: '16px', borderBottom: '1px solid #f1f3f4', textAlign: 'center' }}>
                              <div className="d-flex align-items-center justify-content-center">
                                <button
                                  className="btn-quantity"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleQuantityChangeDec(item, index);
                                  }}
                                  style={{
                                    width: '32px',
                                    height: '32px',
                                    border: '1px solid #dee2e6',
                                    borderRadius: '6px',
                                    backgroundColor: 'white',
                                    color: '#6c757d',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    transition: 'all 0.2s ease',
                                  }}
                                >
                                  <FaMinus size={10} />
                                </button>
                                <span
                                  style={{
                                    margin: '0 16px',
                                    fontWeight: '600',
                                    fontSize: '16px',
                                    minWidth: '24px',
                                    textAlign: 'center',
                                  }}
                                >
                                  {item.quantity}
                                </span>
                                <button
                                  className="btn-quantity"
                                  disabled={outOfStock || atMax || true}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleQuantityChange(item, index);
                                  }}
                                  style={{
                                    width: '32px',
                                    height: '32px',
                                    border: '1px solid #dee2e6',
                                    borderRadius: '6px',
                                    backgroundColor: outOfStock || atMax ? '#f1f3f5' : 'white',
                                    color: outOfStock || atMax ? '#adb5bd' : '#6c757d',
                                    cursor: outOfStock || atMax ? 'not-allowed' : 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    transition: 'all 0.2s ease',
                                  }}
                                  title={outOfStock ? 'Out of stock' : atMax ? `Max available: ${cachedStockQty}` : 'Increase quantity'}
                                >
                                  <FaPlus size={10} />
                                </button>
                              </div>
                            </td>
                            <td style={{ padding: '16px', borderBottom: '1px solid #f1f3f4', textAlign: 'right' }}>
                              <div style={{ fontWeight: '600', fontSize: '15px', color: '#212529' }}>
                                {Currency?.currency?.code} {(itemTotal - itemDiscount * item.quantity).toFixed(2)}
                              </div>
                            </td>
                            <td style={{ padding: '16px', borderBottom: '1px solid #f1f3f4', textAlign: 'center' }}>
                              <div className="d-flex justify-content-center gap-2">
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDelete(item?.item?.itemNo || item?.item?.recordId, index);
                                  }}
                                  style={{
                                    width: '32px',
                                    height: '32px',
                                    border: '1px solid #ffc107',
                                    borderRadius: '6px',
                                    backgroundColor: '#fff3cd',
                                    color: '#856404',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'all 0.2s ease',
                                  }}
                                >
                                  <Delete width={16} height={16} />
                                </button>
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setIsEditModalOpen(true);
                                    setSelectedCartItem(item);
                                  }}
                                  style={{
                                    width: '32px',
                                    height: '32px',
                                    border: '1px solid #17a2b8',
                                    borderRadius: '6px',
                                    backgroundColor: '#d1ecf1',
                                    color: '#0c5460',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'all 0.2s ease',
                                  }}
                                >
                                  <BiEdit size={16} />
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                {/* Fixed Cart Summary */}
                <div className="p-4 border-top" style={{ backgroundColor: '#f8f9fa', flexShrink: 0 }}>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="row g-3">
                        <div className="col-6">
                          <div className="text-center">
                            <div style={{ fontSize: '24px', fontWeight: '700', color: '#212529' }}>{cartData.length}</div>
                            <div style={{ fontSize: '12px', color: '#6c757d', fontWeight: '500' }}>Items</div>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="text-center">
                            <div style={{ fontSize: '24px', fontWeight: '700', color: '#212529' }}>
                              {cartData.reduce((sum, item) => sum + item.quantity, 0)}
                            </div>
                            <div style={{ fontSize: '12px', color: '#6c757d', fontWeight: '500' }}>Quantity</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="text-end">
                        <div style={{ fontSize: '14px', color: '#6c757d', marginBottom: '4px' }}>
                          Subtotal: {Currency?.currency?.code} {calculateTotalPrice().toFixed(2)}
                        </div>
                        {calculateTotalTax() > 0 && (
                          <div style={{ fontSize: '14px', color: '#6c757d', marginBottom: '4px' }}>
                            Tax: {Currency?.currency?.code} {calculateTotalTax().toFixed(2)}
                          </div>
                        )}
                        {calculateTotalDiscount() > 0 && (
                          <div style={{ fontSize: '14px', color: '#28a745', marginBottom: '8px' }}>
                            Discount: -{Currency?.currency?.code} {calculateTotalDiscount().toFixed(2)}
                          </div>
                        )}
                        <div style={{ fontSize: '24px', fontWeight: '700', color: '#212529' }}>
                          {Currency?.currency?.code} {totalAmount.toFixed(2)}
                        </div>
                        <div style={{ fontSize: '12px', color: '#6c757d', fontWeight: '500' }}>Total Amount</div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Fixed Action Buttons */}
                <div className="p-4 border-top" style={{ flexShrink: 0 }}>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <button
                        onClick={handleDisable}
                        className="btn w-100"
                        style={{
                          backgroundColor: '#6e5199',
                          color: 'white',
                          border: 'none',
                          borderRadius: '8px',
                          padding: '14px',
                          fontSize: '16px',
                          fontWeight: '600',
                          transition: 'all 0.2s ease',
                          boxShadow: '0 2px 4px rgba(40, 167, 69, 0.2)',
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = '#6e5159';
                          e.target.style.transform = 'translateY(-1px)';
                          e.target.style.boxShadow = '0 4px 8px rgba(40, 167, 69, 0.3)';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = '#6e5199';
                          e.target.style.transform = 'translateY(0)';
                          e.target.style.boxShadow = '0 2px 4px rgba(40, 167, 69, 0.2)';
                        }}
                      >
                        <FaReceipt className="me-2" />
                        Pay Order
                      </button>
                    </div>
                    <div className="col-md-6">
                      <button
                        onClick={handleclearCart}
                        className="btn w-100"
                        style={{
                          backgroundColor: '#dc3545',
                          color: 'white',
                          border: 'none',
                          borderRadius: '8px',
                          padding: '14px',
                          fontSize: '16px',
                          fontWeight: '600',
                          transition: 'all 0.2s ease',
                          boxShadow: '0 2px 4px rgba(220, 53, 69, 0.2)',
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = '#c82333';
                          e.target.style.transform = 'translateY(-1px)';
                          e.target.style.boxShadow = '0 4px 8px rgba(220, 53, 69, 0.3)';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = '#dc3545';
                          e.target.style.transform = 'translateY(0)';
                          e.target.style.boxShadow = '0 2px 4px rgba(220, 53, 69, 0.2)';
                        }}
                      >
                        Clear Cart
                      </button>
                    </div>
                  </div>

                  <div className="row g-3 mt-2">
                    <div className="col-md-6">
                      <button
                        onClick={() => {
                          handleHoldPayment();
                        }}
                        className="btn w-100"
                        style={{
                          backgroundColor: '#6e5199',
                          color: '#fff',
                          border: 'none',
                          borderRadius: '8px',
                          padding: '12px',
                          fontSize: '14px',
                          fontWeight: '600',
                          transition: 'all 0.2s ease',
                          boxShadow: '0 2px 4px rgba(255, 193, 7, 0.2)',
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = '#6e5159';
                          e.target.style.transform = 'translateY(-1px)';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = '#6e5199';
                          e.target.style.transform = 'translateY(0)';
                        }}
                      >
                        <FaClock className="me-2" />
                        Suspend Sale
                      </button>
                    </div>
                    <div className="col-md-6">
                      <button
                        onClick={() => setIsHeldModalOpen(true)}
                        className="btn w-100"
                        style={{
                          backgroundColor: '#6c757d',
                          color: 'white',
                          border: 'none',
                          borderRadius: '8px',
                          padding: '12px',
                          fontSize: '14px',
                          fontWeight: '600',
                          transition: 'all 0.2s ease',
                          boxShadow: '0 2px 4px rgba(108, 117, 125, 0.2)',
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = '#5a6268';
                          e.target.style.transform = 'translateY(-1px)';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = '#6c757d';
                          e.target.style.transform = 'translateY(0)';
                        }}
                      >
                        <FaArchive className="me-2" />
                        Resume Sale
                      </button>
                    </div>
                  </div>

                  <div className="row g-3 mt-2">
                    <div className="col-md-6">
                      <button
                        onClick={() => setDiscountModalOpen(true)}
                        className="btn w-100"
                        style={{
                          backgroundColor: '#6e5199',
                          color: 'white',
                          border: 'none',
                          borderRadius: '8px',
                          padding: '10px',
                          fontSize: '14px',
                          fontWeight: '500',
                          transition: 'all 0.2s ease',
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = '#6e5150';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = '#6e5199';
                        }}
                      >
                        <TbFlagDiscount className="me-2" />
                        Add Discount
                      </button>
                    </div>
                    {!areTaxDisable && (
                      <div className="col-md-6">
                        <button
                          onClick={() => setTaxModalOpen(true)}
                          className="btn w-100"
                          style={{
                            backgroundColor: '#6f42c1',
                            color: 'white',
                            border: 'none',
                            borderRadius: '8px',
                            padding: '10px',
                            fontSize: '14px',
                            fontWeight: '500',
                            transition: 'all 0.2s ease',
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#5a32a3';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = '#6f42c1';
                          }}
                        >
                          <HiOutlineTag className="me-2" />
                          Add Tax
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </>
      ) : (
        <div style={cardStyle} className="p-4">
          <div className="mb-4">
            <h5 className="d-flex align-items-center mb-0" style={{ fontWeight: '600', color: '#495057' }}>
              <FaReceipt className="me-2" />
              Payment Processing
            </h5>
          </div>

          {/* FLOW CASH (Flocash) */}

          <div className="row">
            <div className="col-lg-6">
              <div className="row g-4">
                {/* Order Amount (readonly) */}
                <div className="col-12">
                  <label className="form-label" style={{ fontWeight: '600', color: '#495057', marginBottom: '8px' }}>
                    Order Amount
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={`${Currency?.currency?.code} ${totalAmount.toFixed(2)}`}
                    disabled
                    style={{
                      backgroundColor: '#f8f9fa',
                      border: '1px solid #dee2e6',
                      borderRadius: '8px',
                      padding: '12px 16px',
                      fontSize: '16px',
                      fontWeight: '600',
                    }}
                  />
                </div>

                {/* Amount Collected */}
                <div className="col-12">
                  <label className="form-label" style={{ fontWeight: '600', color: '#495057', marginBottom: '8px' }}>
                    Amount Collected
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    name="amountCollected"
                    value={isEditingAmount ? formData.amountCollected ?? '' : formData.amountCollected ?? totalAmount}
                    onChange={(e) => {
                      setIsEditingAmount(true);
                      handleInputChange(e);
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#dee2e6';
                      e.target.style.boxShadow = 'none';
                      if (e.target.value === '') setIsEditingAmount(false);
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#007bff';
                      e.target.style.boxShadow = '0 0 0 0.2rem rgba(0, 123, 255, 0.25)';
                    }}
                    step="0.01"
                    min="0"
                    style={{
                      border: '2px solid #dee2e6',
                      borderRadius: '8px',
                      padding: '12px 16px',
                      fontSize: '16px',
                      transition: 'border-color 0.2s ease',
                    }}
                  />
                </div>

                {/* Amount Return (change) */}
                <div className="col-12">
                  <label className="form-label" style={{ fontWeight: '600', color: '#495057', marginBottom: '8px' }}>
                    Amount Return
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={formData.change.toFixed(2)}
                    disabled
                    style={{
                      backgroundColor: formData.change > 0 ? '#d4edda' : '#f8f9fa',
                      border: `1px solid ${formData.change > 0 ? '#c3e6cb' : '#dee2e6'}`,
                      borderRadius: '8px',
                      padding: '12px 16px',
                      fontSize: '16px',
                      fontWeight: '600',
                      color: formData.change > 0 ? '#155724' : '#6c757d',
                    }}
                  />
                </div>

                {/* CARD FIELDS */}
                {isCardPayment && (
                  <>
                    <div className="col-12">
                      <label className="form-label" style={{ fontWeight: '600', color: '#495057', marginBottom: '8px' }}>
                        Last 4 Digits
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="cardLast4Digits"
                        value={formData.cardLast4Digits || ''}
                        maxLength={4}
                        onChange={(e) => {
                          const v = e.target.value.replace(/\D/g, '').slice(0, 4); // only digits, max 4
                          handleInputChange({ target: { name: 'cardLast4Digits', value: v } });
                        }}
                        placeholder="e.g. 1234"
                        style={{
                          border: '2px solid #dee2e6',
                          borderRadius: '8px',
                          padding: '10px 14px',
                          fontSize: '14px',
                        }}
                      />
                    </div>
                    <div className="col-12">
                      <label className="form-label" style={{ fontWeight: '600', color: '#495057', marginBottom: '8px' }}>
                        Approval Number
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="cardApprovalNo"
                        value={formData.cardApprovalNo || ''}
                        onChange={handleInputChange}
                        placeholder="Approval number #"
                        style={{
                          border: '2px solid #dee2e6',
                          borderRadius: '8px',
                          padding: '10px 14px',
                          fontSize: '14px',
                        }}
                      />
                    </div>
                  </>
                )}
                {isAccountPayment && (
                  <div className="col-12">
                    <label className="form-label" style={{ fontWeight: '600', color: '#495057', marginBottom: '8px' }}>
                      Account Number
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="accountNumber"
                      value={formData.accountNumber || ''}
                      onChange={handleInputChange}
                      placeholder="Enter account number"
                      style={{
                        border: '2px solid #dee2e6',
                        borderRadius: '8px',
                        padding: '10px 14px',
                        fontSize: '14px',
                      }}
                    />
                  </div>
                )}

                {/* EFT FIELDS */}
                {isEftPayment && (
                  <>
                    <div className="col-12">
                      <label className="form-label" style={{ fontWeight: '600', color: '#495057', marginBottom: '8px' }}>
                        EFT Reference Code
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="eftReference"
                        value={formData.eftReference || ''}
                        onChange={handleInputChange}
                        placeholder="Bank / EFT reference"
                        style={{
                          border: '2px solid #dee2e6',
                          borderRadius: '8px',
                          padding: '10px 14px',
                          fontSize: '14px',
                        }}
                      />
                    </div>
                  </>
                )}

                {/* Customer (same as before) */}
                <div className="col-12">
                  <label className="form-label" style={{ fontWeight: '600', color: '#495057', marginBottom: '8px' }}>
                    Customer
                  </label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      value={formData.customerName?.label || ''}
                      disabled
                      style={{
                        backgroundColor: '#f8f9fa',
                        border: '1px solid #dee2e6',
                        borderRadius: '8px 0 0 8px',
                        padding: '12px 16px',
                      }}
                    />
                    <button
                      className="btn"
                      onClick={() => setShow(true)}
                      style={{
                        backgroundColor: '#007bff',
                        color: 'white',
                        border: '1px solid #007bff',
                        borderRadius: '0 8px 8px 0',
                        padding: '12px 16px',
                        transition: 'all 0.2s ease',
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#0056b3';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = '#007bff';
                      }}
                    >
                      <MdPersonAddAlt1 size={18} />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Calculator on the right for Cash / Card / EFT */}
            <div className="col-lg-6">
              <Calculator handleInput={handleInputFromCalculator} />
            </div>
          </div>

          {/* Enhanced Payment Buttons */}
          <div className="row g-3 mt-4">
            <div className="col-md-6">
              <button
                className="btn w-100"
                onClick={handleEnable}
                style={{
                  backgroundColor: '#6c757d',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '14px',
                  fontSize: '16px',
                  fontWeight: '600',
                  transition: 'all 0.2s ease',
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#5a6268';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#6c757d';
                }}
              >
                <BackArrow className="me-2" width={16} />
                Back to Cart
              </button>
            </div>
            <div className="col-md-6">
              <button
                onClick={placeOrder}
                className={`btn w-100 ${!isPaymentFormValid || isPlacingOrder ? 'disabled' : ''}`}
                disabled={!isPaymentFormValid || isPlacingOrder}
                style={{
                  backgroundColor: !isPaymentFormValid || isPlacingOrder ? '#e9ecef' : '#28a745',
                  color: !isPaymentFormValid || isPlacingOrder ? '#6c757d' : 'white',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '14px',
                  fontSize: '16px',
                  fontWeight: '600',
                  transition: 'all 0.2s ease',
                  cursor: !isPaymentSufficient || isPlacingOrder ? 'not-allowed' : 'pointer',
                }}
              >
                {isPlacingOrder ? <div className="spinner-border spinner-border-sm me-2" role="status"></div> : <FaReceipt className="me-2" />}
                {isPlacingOrder ? 'Processing...' : 'Complete Order'}
                {!isPaymentSufficient && ` (Need ${Currency?.currency?.code}${(totalAmount - (parseFloat(formData.amountCollected) || 0)).toFixed(2)} more)`}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modals */}
      <Modal show={isEditModalOpen} onHide={() => setIsEditModalOpen(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Edit Item</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedCartItem && (
            <CartPopup
              CartValue={selectedCartItem?.item}
              selectedAdOn={selectedCartItem?.selectedAdOn}
              selectedModifier={selectedCartItem?.selectedModifier}
              selectedVariant={selectedCartItem?.selectedVariant}
              closeModal={() => setIsEditModalOpen(false)}
              isEdit={true}
              editingItem={selectedCartItem}
              Currency={Currency}
            />
          )}
        </Modal.Body>
      </Modal>

      {/* <Modal show={discountModal} onHide={closeDiscountModal} size="lg"> */}
      {discountModal && <DiscountModal closeDiscountModal={closeDiscountModal} />}
      {/* </Modal> */}

      <Modal show={TaxModal} onHide={closeTaxModal} size="md">
        <Modal.Header closeButton>
          <Modal.Title className="center">Add Tax</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Select
            isMulti
            options={taxes?.map((tax) => ({ value: tax, label: tax?.name }))}
            value={selectedTaxPercentage}
            onChange={handleSelectedTax}
            className=""
            isClearable
          />
        </Modal.Body>
        <Modal.Footer className="end p-3">
          <button className="AddBtn" onClick={closeTaxModal}>
            Save
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add Customer</Modal.Title>
        </Modal.Header>
        <div className="p-4">
          <div className="mb-3">
            <CreatableSelect
              isMulti={false}
              options={Customers?.map((Items) => ({
                value: Items,
                label: `${Items.name} (${Items.mobileNumber || Items.phoneNumber})`,
              }))}
              value={formData?.customerName}
              onChange={handleCustomerSelect}
              placeholder="Select or search customer..."
              className=""
              isClearable
              // FIXED: Enable creating new options
              onCreateOption={(inputValue) => {
                // Optional: Handle inline customer creation
                console.log('Create new customer:', inputValue);
              }}
            />
          </div>

          <CustomerCreatePOpup
            orderType={orderType}
            GetCostumer={GetCostumer}
            close={handleClose}
            selectedCustomer={formData?.customerName || { value: null }}
            address={formData?.address}
            onCustomerCreated={handleCustomerCreated} // FIXED: Pass the callback
          />
        </div>
      </Modal>

      {/* Held Orders Modal */}
      <Modal show={isHeldModalOpen} onHide={closeHeldModal} size="sm">
        <Modal.Header closeButton>
          <Modal.Title>Held Orders</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="p-3">
            {heldOrders?.length === 0 ? (
              <p className="text-center text-muted">No held orders found</p>
            ) : (
              heldOrders?.map((heldOrder, index) => (
                <div className="p-3 mb-2 border rounded cursor-pointer" key={index} onClick={() => handleHeldOrder(heldOrder)} style={{ cursor: 'pointer' }}>
                  <div className="d-flex justify-content-between">
                    <div>
                      <strong>Order #{heldOrder.id}</strong>
                      <div className="text-muted small">{formatDate(heldOrder.orderDate)}</div>
                      <div className="text-muted small">Items: {heldOrder.orderItems?.length || 0}</div>
                    </div>
                    <div className="text-end">
                      <div className="h6">
                        {Currency?.currency?.code} {heldOrder.orderAmount?.toFixed(2)}
                      </div>
                      <div className="text-muted small">{heldOrder.customerName || 'Guest'}</div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

const mapStatetoProps = (state) => state;
const mapDispatchToProps = {
  updateCartItemQuantity,
};

export default connect(mapStatetoProps, mapDispatchToProps)(CashierBucket);
